module.exports = __webpack_public_path__ + "static/media/classic_1.ee134048.png";